import { render, staticRenderFns } from "./searchProjectDialog.vue?vue&type=template&id=1fe3a89a&scoped=true"
import script from "./searchProjectDialog.vue?vue&type=script&lang=js"
export * from "./searchProjectDialog.vue?vue&type=script&lang=js"
import style0 from "./searchProjectDialog.vue?vue&type=style&index=0&id=1fe3a89a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe3a89a",
  null
  
)

export default component.exports